import { render, staticRenderFns } from "./CoPilotAttrNode.vue?vue&type=template&id=8edca9b2"
import script from "./CoPilotAttrNode.vue?vue&type=script&lang=js"
export * from "./CoPilotAttrNode.vue?vue&type=script&lang=js"
import style0 from "./CoPilotAttrNode.vue?vue&type=style&index=0&id=8edca9b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports